export default [
    {
        path: 'relatorio-exame-bloqueado',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-exame-bloqueado' */
            '@/views/exame-laboratorial/relatorio-exame-bloqueado/Index'
        ),
        redirect: 'relatorio-exame-bloqueado/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-exame-bloqueado-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-exame-bloqueado' */
                    '@/views/exame-laboratorial/relatorio-exame-bloqueado/List.vue'
                ),
            },
        ],
    },
]